import { useCallback } from 'react';

import type {
	PaymentReason,
	PaymentReasonType,
} from '~features/annals/enums/payment';

import type { PaywallIntentParams } from './types';

class Content {
	static requestedPaywallIntent: BotPaywallIntentParams | undefined = undefined;
}

export type BotPaywallIntentParams = PaywallIntentParams & {
	botId: string;
	reason: PaymentReason;
	reasonType: PaymentReasonType;
};

export const useNeedsToShowBotPaywall = () => {
	const setNeedsToShowBotPaywall = useCallback(
		(state: BotPaywallIntentParams | undefined) => {
			Content.requestedPaywallIntent = state;
		},
		[]
	);

	return {
		requestedPaywallBotData: Content.requestedPaywallIntent,
		setNeedsToShowBotPaywall,
	};
};
